import { useKeyboard } from "client/hooks/utils/useKeyboard";
import { deleteTextBox } from "store/features/memeGenerator/actions";
import { TextBoxStates } from "store/features/memeGenerator/types";
import { store, useAppDispatch } from "store/store";

export const useTextSettings = () => {
    const dispatch = useAppDispatch();
    function handleDelete() {
        const activeTextBoxId = store.getState().memeGenerator.meme?.activeTextBoxId;
        if (!activeTextBoxId) return;
        const textBox = store.getState().memeGenerator.meme?.textBoxes.find((t) => t.id === activeTextBoxId);
        if (!textBox || textBox.state === TextBoxStates.INSERT) return;
        dispatch(deleteTextBox(activeTextBoxId));
    }
    useKeyboard("Backspace", true, handleDelete);
    useKeyboard("Delete", true, handleDelete);
    return {};
};
